<template>
    <a-select
            showSearch
            v-model="model"
            :placeholder="placeholder"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            @search="handleSearch"
            @change="handleChange"
            @select="onSelect"
            :notFoundContent="null"
    >
        <a-select-option :key="index" v-for="(option,index) in options"  :value="option.id" >{{option.name}}({{option.num}}) {{option.sex}}</a-select-option>
    </a-select>
</template>
<script>
    import { getOptions} from '@/api/kaoguan';
    export default {
    name: 'KaoguanPicker',
    data () {
      return {
        model:undefined,
          options:[]
      }
    },
    props: {
        placeholder:{
            type: String,
            default:'请选择考官'
        },
        user_id:{
            type: Number,
            default:0
        },
        danwei_id:{
            type: Number,
            default:0
        }, 
    },
    computed:{
    },
        filters:{

        },
      watch: {
      },
      created(){
      },
    methods: {
        handleSearch(value){
            let that = this;
            getOptions({ keywords: value ,user_id:that.user_id,danwei_id: that.danwei_id}).then(res => {
                that.options = res.data
            })
       },
        handleChange(value){
        //    this.formData[this.field] = value;
            console.log('picker- handleChange',value);
            this.$emit("onChange", value);
       },
        onSelect(value){
        //    this.formData[this.field] = value;
            console.log('picker- onSelect',value);
            
            this.$emit("onSelect", this.options.filter((item) =>{
                return item.id == value
            })[0]);
       }
    },
  }
</script>
<style>

</style>